module.exports = __webpack_public_path__ + "media/baby_roshan.6d16cdeb.webm";